var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',{model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},_vm._l((_vm.items),function(item,i){return _c('v-tab',{key:i},[_vm._v(" "+_vm._s(_vm.$t(item.label))+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }